export default (function (element) {
    return (element && element.ownerDocument) || document;
});



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/owner-document.js
// module id = 345
// module chunks = 93